export const webLocalStorage = {
    async getItem(key) {
        if (typeof window !== "undefined" && window.localStorage) {
            return localStorage.getItem(key);
        }
        return null;
    },
    async setItem(key, value) {
        if (typeof window !== "undefined" && window.localStorage) {
            localStorage.setItem(key, value);
        }
    },
    async removeItem(key) {
        if (typeof window !== "undefined" && window.localStorage) {
            localStorage.removeItem(key);
        }
    },
};
//# sourceMappingURL=webStorage.js.map